module.exports = __webpack_public_path__ + "assets/media/allow-notifications-explainer.1932fb4b.png";